import ClientBase from "../ClientBase";

const BASE_URL = "api/v1/scanreviewrequests";

// Duallo-staff review queue: scans parked in awaiting-duallo-review by the AI
// pipeline. Read-only — entries are opened/resolved server-side by the
// inference-complete callback and the accept/reject admin actions.
class ScanReviewRequestClient extends ClientBase {

    // status: "Pending" | "Accepted" | "Rejected" | null (all)
    async getReviewRequests(status = null) {
        const query = status ? `?status=${encodeURIComponent(status)}` : "";
        return await this.get(`${BASE_URL}${query}`) ?? [];
    }
}

export default new ScanReviewRequestClient();
